import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Activity, Bell, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const STATUS_URL = "https://emrkt.betteruptime.com";

const Status = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SiteHeader />
      <main className="flex-1 pt-32 pb-16">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium mb-4">
              <Activity className="h-3.5 w-3.5" />
              System Status
            </div>
            <h1 className="font-display text-4xl md:text-5xl font-bold mb-3">
              Platform Status
            </h1>
            <p className="text-muted-foreground text-lg max-w-2xl">
              Real-time uptime and incident history for emrkt.co. Monitored independently by BetterStack.
            </p>
            <div className="flex flex-wrap gap-3 mt-6">
              <a href={STATUS_URL} target="_blank" rel="noopener noreferrer">
                <Button variant="outline" size="sm">
                  <Bell className="h-4 w-4 mr-2" />
                  Subscribe to updates
                </Button>
              </a>
              <a href={STATUS_URL} target="_blank" rel="noopener noreferrer">
                <Button variant="ghost" size="sm">
                  Open full status page
                  <ExternalLink className="h-4 w-4 ml-2" />
                </Button>
              </a>
            </div>
          </div>

          <div className="rounded-[0.875rem] overflow-hidden border border-border bg-card shadow-elegant">
            <iframe
              src={STATUS_URL}
              title="emrkt.co status page"
              className="w-full bg-white"
              style={{ height: "1400px", border: 0 }}
              loading="lazy"
            />
          </div>

          <p className="text-xs text-muted-foreground mt-6 text-center">
            Status data provided by BetterStack — independent of emrkt.co infrastructure.
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default Status;